<template>
	<div class="studytrain">
		<headerview :cur="4"></headerview>

		<div class="content">

			<div class="moddlecon w13 min-h">
				<div class="tipcon">
					<tipcon :title="'学习资料'" :name="'学习资料'" :imgtype="'4'" width="2.23"></tipcon>
				</div>

				<div class="study_c">
					<div class="l_c">
						<filelibrary></filelibrary>
					</div>
					<div class="r_c">
						<studylist></studylist>
					</div>
				</div>

				<div class="network">
					<tipheader :maxtitle="'网络'" :mintitle="'课堂'" :pathUrl="'/networkroom?type='+tabAct"
					:ifimg="true" :width="'1.31'" :sign="'2'"></tipheader>
				</div>
				<div>
					<networkclass @onChangeTab='onChangeTab'></networkclass>
				</div>

				<div class="culture">
					<tipheader :maxtitle="'文化'" :mintitle="'产品'"
					:ifimg="false" :width="'1.31'"></tipheader>
				</div>

				<div class="videoandposter">
					<div class="video_l">
						<div class="t_c_public">
							<div class="spanimg">
								<img class="imga" src="../../../static/img/culture_a@2x.png" alt=""/>
								<span>视频</span>
							</div>
							<img src="../../../static/img/rightarrow@2x.png" alt="" @click="toculpro(0)"/>
						</div>

						<div class="frame">
							<div class="signle" v-for="(item,index) in lista" :key="index" @click="toculdetail(0,item)">
								<el-image fit='cover' style="width:100%!important;" :src="$imgUrl + item.picture_dictText" alt=""></el-image>
								<div class="signle_text overfh" :title="item.title">{{item.title || ''}}</div>
							</div>
						</div>
					</div>
					<div class="poster_r">
						<div class="t_c_public">
							<div class="spanimg">
								<img class="imgb" src="../../../static/img/culture_b@2x.png" alt=""/>
								<span>海报</span>
							</div>
							<img src="../../../static/img/rightarrow@2x.png" alt="" @click="toculpro(1)"/>
						</div>

						<div class="frame">
							<div class="signle" v-for="(item,index) in listb" :key="index" @click="toculdetail(1,item)">
								<el-image fit='cover' :src="$imgUrl + item.picture_dictText" alt=""></el-image>
							</div>
						</div>
					</div>
				</div>

				<div class="imagetextlist">
					<div class="graphic">
						<div class="t_c_public">
							<div class="spanimg">
								<img class="imga" src="../../../static/img/culture_c@2x.png" alt=""/>
								<span>图解</span>
							</div>
							<img src="../../../static/img/rightarrow@2x.png" alt="" @click="toculpro(2)"/>
						</div>
						<div class="titlename_public">
							<div class="col overfh" :title='item.title' v-for="(item,index) in listc" :key="index" @click="toculdetail(2,item)">
								 {{item.title||''}}
							</div>
						</div>

					</div>
					<div class="paganda">
						<div class="t_c_public">
							<div class="spanimg">
								<img class="imgb" src="../../../static/img/culture_d@2x.png" alt=""/>
								<span>宣讲图文</span>
							</div>
							<img src="../../../static/img/rightarrow@2x.png" alt="" @click="toculpro(3)"/>
						</div>
						<div class="titlename_public">
							<div class="col overfh" :title='item.title' v-for="(item,index) in listd" :key="index" @click="toculdetail(3,item)">
								{{item.title||''}}
							</div>
						</div>
					</div>
					<div class="journal">
						<div class="t_c_public">
							<div class="spanimg">
								<img class="imgc" src="../../../static/img/culture_e@2x.png" alt=""/>
								<span>电子刊</span>
							</div>
							<img src="../../../static/img/rightarrow@2x.png" alt="" @click="toculpro(4)"/>
						</div>
						<div class="titlename_public">
							<div class="col overfh" :title='item.title' v-for="(item,index) in liste" :key="index" @click="toculdetail(4,item)">
								{{item.title||''}}
							</div>
						</div>
					</div>
				</div>

				<div class="song">
					<div class="t_c_public">
						<div class="spanimg">
							<img class="imga" src="../../../static/img/culture_f@2x.png" alt=""/>
							<span>歌曲</span>
						</div>
						<img src="../../../static/img/rightarrow@2x.png" alt="" @click="toculpro(5)"/>
					</div>

					<div class="name">
						<div class="songname overfh" :title='item.title' v-for="(item,index) in listf" :key="index" @click="toculdetail(5,item)">
							{{item.title||''}}
						</div>
					</div>

				</div>
				<div class="f-row-start-b excellentbox">
					<div class="excellent-item">
						<div class="excellent">
							<tipheader :maxtitle="'标准'" :mintitle="'队课'"
							:ifimg="true" :width="'1.31'" :sign="'3'"></tipheader>
						</div>

						<div class="titlelist f-row-l wrap">
							<div class="signle" v-for="(item,index) in exclist" :key="index" @click="toexceldetail(item)">
								<!-- <videobox :file="''" numH='159px'></videobox> -->
								<el-image fit='cover' style="height:159px;width:100%;" :src='item.coverId_dictText?$imgUrl+item.coverId_dictText:""'></el-image>
								<div class="title overfh" :title='item.title'>
									{{item.title||''}}
								</div>
								<!-- <div class="name">{{item.createTime.split(' ')[0] || ''}}</div> -->
							</div>
						</div>
					</div>
					<div class="excellent-item">
						<downbox maxtitle='证书' mintitle='模板' :ifimg='true' :sign='6' pathUrl='/downloadlist?signtype=6' linTxt=''></downbox>
					</div>

				</div>


			</div>

		</div>

		<footview></footview>

	</div>

</template>

<script>

import tipcon from "../../../com/tipcon.vue";
import tipheader from "../../../com/tipheader.vue";
import filelibrary from "../../../com/filelibrary.vue";
import studylist from "../../../com/studylist.vue";
import networkclass from "../../../com/networkclass.vue";
// import videobox from '../../../com/videobox.vue'
import downbox from '../../../com/downbox.vue'

export default {
  components: {
  	  tipcon,
	  tipheader,
	  filelibrary,
	  studylist,
	  networkclass,
	//   videobox,
	  downbox
  },

  data: function() {
    return {
         exclist:[],
		 lista:[],
		 listb:[],
		 listc:[],
		 listd:[],
		 liste:[],
		 listf:[],
		tabAct:1,
    };
  },

  mounted() {
		this.$onScrollT();

		this.getCulturallist()
		this.getlista();
		this.getlistb();
		this.getlistc();
		this.getlistd();
		this.getliste();
		this.getlistf();
  },

  methods: {
	  	onChangeTab(e){
			this.tabAct=e
		},
		getlista(){
			this.$get(`web/culturalproduct/list?pageSize=2&pageNo=1&productType=1`).then(res=>{
				if(res.success){
					this.lista = res.result.records;
				}
			})
		},
		getlistb(){
			this.$get(`web/culturalproduct/list?pageSize=4&pageNo=1&productType=2`).then(res=>{
				if(res.success){
					this.listb = res.result.records;
				}
			})
		},
		getlistc(){
			this.$get(`web/culturalproduct/list?pageSize=6&pageNo=1&productType=3`).then(res=>{
				if(res.success){
					this.listc = res.result.records;
				}
			})
		},
		getlistd(){
			this.$get(`web/culturalproduct/list?pageSize=6&pageNo=1&productType=4`).then(res=>{
				if(res.success){
					this.listd = res.result.records;
				}
			})
		},
		getliste(){
			this.$get(`web/culturalproduct/list?pageSize=6&pageNo=1&productType=5`).then(res=>{
				if(res.success){
					this.liste = res.result.records;
				}
			})
		},
		getlistf(){
			this.$get(`web/culturalproduct/list?pageSize=5&pageNo=1&productType=6`).then(res=>{
				if(res.success){
					this.listf = res.result.records;
				}
			})
		},

		getCulturallist(){
			this.$get(`web/culturalproduct/datalist?pageSize=4&pageNo=1&dataType=1`).then(res=>{
				if(res.success){
					this.exclist = res.result.records;
				}
			})
		},

		toexceldetail(item){
			this.$router.push({ path: '/excellentcases_detail?id='+item.id + '&type=2'});
		},

		toculpro(sign){
			this.$router.push({ path: '/culturalpro?type='+ sign });
		},

		toculdetail(sign,item){
			this.$router.push({ path: '/culturalpro?type='+ sign +'&id='+item.id});
		},


  },


};
</script>

<style scoped="scoped" lang="scss">

.studytrain{
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
			padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			.study_c{
				margin-top: 40px;
				display: flex;
				.l_c{
					flex: 1;
					margin-right: 40px;
					width: 560px;
				}
				.r_c{
					flex: 1;
					margin-left: 40px;
					width: 560px;
				}
			}

			.network,.culture{
				margin-top: 40px;
			}

			.videoandposter{
				margin-top: 40px;
				display: flex;
				.video_l{
					flex: 1;
					margin-right: 20px;
					.frame{
						margin-top: 20px;
						display: flex;
						justify-content: space-between;
						.signle{
							cursor: pointer;
							font-size: 18px;
							font-weight: 400;
							color: #000000;
							width: calc(50% - 10px);

							img,.el-image{
								height: 162px;
								width: 100%;
							}
							.signle_text{
								width: 100%;
							}
						}
					}
				}
				.poster_r{
					flex: 1;
					margin-left: 40px;
					.frame{
						margin-top: 20px;
						display: flex;
						// justify-content: center;
						.signle{
							cursor: pointer;
							width: 25%;
							img{
								height: 162px;
								width: 119px;
							}
						}
					}
				}
			}

			.imagetextlist{
				margin-top: 40px;
				display: flex;
				justify-content: space-between;
				.graphic,.paganda,.journal{
					flex: 1;
					min-height: 320px;
					width: calc(25% - 20px);
					.titlename_public{
						.col{
							cursor: pointer;
							width: 100%;
						}
						.col:hover{
							color:#E61F26;
						}
					}
				}
				.graphic{
					margin-right: 20px;
				}
				.paganda{
					margin-left: 20px;
					margin-right: 20px;
				}
				.journal{
					margin-left: 20px;
				}
			}

			.song{
				margin-top: 40px;
				width: 100%;
				overflow: hidden;
				.name{
					margin: 40px 0px 0px 0px;
					// margin: 40px 40px 0px 40px;
					display: flex;
					justify-content: flex-start;
					flex-wrap: wrap;
					.songname{
						margin-left: 40px;
						margin-right: 40px;
						box-sizing: border-box;
						width: calc(20% - 80px);
						// text-align: center;
						cursor: pointer;
						font-size: 18px;
						font-weight: 400;
						color: #000000;
					}
					.songname:hover{
						color:#E61F26;
					}
				}
			}
			.excellentbox{
				margin-top: 40px;
				margin-bottom: 40px;
				.excellent{

				}
				.excellent-item{
					width: calc(50% - 30px);
				}
			}


			.titlelist{
				margin: 20px 0px 100px;
				.signle{
					cursor: pointer;
					width: calc(50% - 10px);
					margin-left:20px;
					margin-bottom: 5px;
					.title,.name{
						font-size: 18px;
						font-weight: 400;
						color: #333333;
					}
					.title{
						height: 40px;
						line-height: 40px;
						width: 100%;
					}
					.name{
						width: 120px;
					}
				}
				.signle:nth-child(2n+1){
					margin-left: 0px;
				}
			}

		}

	}



}

</style>
